import gql from 'graphql-tag';

export const GetLeadByIdQuery = gql`
  query GetLead($id: String){
    lead(id: $id) {
    id
    firstName
    lastName
    emailAddress1
    userType
    zipCode
    address1_City
    address1_Line1
    address1_PostalCode
    address1_StateOrProvince
    telephone1
    licenseNumber
    }
  }
`;
